import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AccessSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="access" className="bg-white py-16 md:py-24">
      <div ref={ref} className={`w-full px-4 md:px-8 max-w-5xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <h2 className="font-serif text-xl md:text-3xl font-bold text-clinic-dark text-center mb-3 scroll-reveal-item delay-1">
          通いやすさも、元気への第一歩です
        </h2>
        <p className="text-clinic-gray text-sm md:text-base text-center mb-10 md:mb-14 scroll-reveal-item delay-1">
          守谷駅から徒歩1分。お車でも駐車場完備です
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-14">
          <div className="rounded-xl overflow-hidden h-64 md:h-80 scroll-reveal-item delay-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3229.925220365827!2d139.9915034741175!3d35.948802482857054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189e46866bf43d%3A0xfe24a6e1fb517f33!2z44Gy44KN44Kr44Kk44Ot5pW05L2T6ZmiIOWuiOiwt-W4guOBruiHquW-i-elnue1jOWwgumWgA!5e0!3m2!1sja!2sjp!4v1779100308458!5m2!1sja!2sjp"
              title="ひろカイロ整体院 アクセスマップ"
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="space-y-5 scroll-reveal-item delay-3">
            <div>
              <h3 className="font-bold text-clinic-dark text-base md:text-lg mb-2">立地</h3>
              <p className="text-clinic-dark text-sm md:text-base leading-relaxed">
                茨城県守谷市中央3-15-5
                <br />
                つくばエクスプレス/関東鉄道常総線
                <br />
                守谷駅「八坂口」徒歩1分（路面店で階段なし）
                <br />
                秋葉原駅からつくばエキスプレスで快速32分
              </p>
            </div>
            <div>
              <h3 className="font-bold text-clinic-dark text-base md:text-lg mb-2">駐車場</h3>
              <p className="text-clinic-dark text-sm md:text-base leading-relaxed">
                院のすぐ裏に4台完備<br />
                （お車でも安心です）
              </p>
            </div>
            <div>
              <h3 className="font-bold text-clinic-dark text-base md:text-lg mb-2">料金</h3>
              <p className="text-clinic-dark text-sm md:text-base leading-relaxed">
                自律神経整体
                {' '}
                <span className="font-bold text-clinic-terracotta">7,700円</span>
                （約30分）
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}